import React from 'react'
import Link from 'gatsby-link'
var _utag = null;

export function set_content_type()  
{
    try {
        // TODO
    }catch(errr){}
}
export function track_click($tag_name)
{
    window.dataLayer && window.dataLayer.push({ 
        event : 'other', 
        promo_type : 'other', 
        promo_loc : 'https://www.univision.com' + process.env.PREFIX_PATH, 
        promo_name : $tag_name
    });
}
export default class Tracking extends React.Component {

    track_event(text)
    {
        console.log("hola hola " + text)
    }
    init_track(w,d,s,l,i)
    {
        w[l]=w[l]||[];w[l].push(window.utag_data);w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    }
    componentDidMount()
    {
        var localComplet = new Date();
        var timestamp = String(Date.parse(new Date()));
        var epoch = parseInt(String(Date.now()).substr(0, 10));
        var timestamp_local = String(localFormat(localComplet));
        var timestamp_utc = String(localComplet.toISOString());

        function pad(number) { if (number < 10) { return "0" + number; } return number; }
        function localFormat(item) { return (item.getFullYear() +"-" + pad(item.getMonth() + 1) + "-" +pad(item.getDate()) +"T" +pad(item.getHours()) +":" +pad(item.getMinutes()) +":" +pad(item.getSeconds()) +"." +(item.getMilliseconds() / 1000).toFixed(3).slice(2, 5)); }
        function isMobile() { if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&window.innerWidth <= 1023) {return true;} else {return false;} }

        let page_name = this.props.pageName == undefined ? "todo sobre el torneo mas importante del futbol de europa" : this.props.pageName;
        let permalink = this.props.permalink == undefined ? "https://www.univision.com" + process.env.PREFIX_PATH : this.props.permalink;

        window.utag_data = {
            all_tags:["ucl", "competencias de futbol", "futbol", "deportes"],
            content_author:"",
            content_created_date:"1534518516739",
            content_creator:"00000156-9f3a-d4c7-a957-dfbb097f0000",
            content_id:"00000165-486d-dbb4-a9e5-dbfd46a50000",
            content_modified_date:"1534518516739",
            content_priority:"standard",
            content_type:"article",
            enh_count:1,
            environment_name:"production",
            language:"es",
            page_name:"deportes:ucl:video:liga de campeones: " + page_name,
            parent_tags:["ucl", "competencias de futbol", "futbol", "deportes"],
            parent_topic:"deportes",
            permalink:permalink,
            portal_theme:"deportes",
            primary_tag:"ucl",
            primary_tag_uid:"00000152-3cb4-d0a8-a553-7ebfda1a0000",
            primary_tag_en:"ucl",
            promo_title:"" + page_name,
            pub_name:"juan jorge hernandez",
            publisher_tags:["ucl"],
            short_title:"" + page_name,
            short_title_en:"" + page_name,
            source:"univisiondeportes.com",
            tags_en:["uefa champions league", "soccer competitions", " soccer", "sports"],
            title:"" + page_name,
            title_en:"" + page_name,
            topics:["deportes"],
            uci_division:"uim-product",
            website:"univision",
            word_count:"1",
            uni_platform:"Website",
            country_code:"co",
            page_load_timestamp:timestamp,
            page_title:page_name + " - univision",
            login_status:"false",
            mvpd_provider:"false",
            embedded_items:"allgridfouritems",
            "qp.layout":"webapp",
            tealium_event:"view",
            tealium_visitor_id:"0161f827bf450002ac73842b6d2904079002207100ac2",
            tealium_session_id:"1527725311959",
            tealium_datasource:"",
            tealium_account:"univision",
            tealium_profile:"main",
            tealium_environment:"prod",
            tealium_random:"6173394453456569",
            tealium_library_name:"utag.js",
            tealium_library_version:"4.42.0",
            tealium_timestamp_epoch:epoch,
            tealium_timestamp_utc:timestamp_utc,
            tealium_timestamp_local:timestamp_local,
            "js_page.UVN.isDesktop":!isMobile(),
            "js_page.UVN.isMobile": isMobile(),
            ga_property_id:"UA-81851967-1",
            undefined:"",
            comments_flag:"",
            event:"",
            url:"",
            video_id:"",
            page_section:"ucl:article",
            uni_now_date:epoch,
            uni_tealium_ver:"ut4.42.201805021812",
            user_agent:navigator.userAgent,
            video_position:null,
            article_view:"1",
            word_count_group:"0-200",
            cb_multiple_sections:"ucl,competencias de futbol,futbol,deportes,article",
            webapp:"webapp"
        };

        this.init_track(window,document,'script','dataLayer','GTM-TDVV9BR');
        
        
        /*var ele1 = document.createElement('script');
        ele1.src = '//tags.tiqcdn.com/utag/univision/main/prod/utag.js'; 
        ele1.type = 'text/javascript'; 
        ele1.async = true;
        document.head.appendChild(ele1);
        ele1.addEventListener("load", () => {
            _utag = utag;
        })*/
    }
    render() {
        return <div id="tracking-utag">
               </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/tracking.js